import { createApp } from 'vue';
import Stories from '../vue/Stories.vue';

export default class LibraryArchive {
	isSubmitting = false;

	constructor(el) {
		this.el = el;
		this.vueComponent = createApp(Stories, {
			data: JSON.parse(this.el.querySelector('script').textContent),
		});
		this.vueComponent.mount(this.el);
	}

	destroy() {
		this.vueComponent.unmount();
	}

	static init() {
		document.addEventListener('bless', (e) => {
			e.target.querySelectorAll('[data-library-archive]').forEach((el) => new LibraryArchive(el));
		});
	}
}
